import React, { useEffect, useState } from 'react';
import * as PetApi from "../../../api/apiPet";
import { Timestamp } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faX } from '@fortawesome/free-solid-svg-icons';
import ReactLoading from 'react-loading';
import { Autocomplete, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const Vaccines = ({ vaccines, pet, userId, setVaccines }) => {
    const [openForm, setOpenForm] = useState(false);
    const [newVaccine, setNewVaccine] = useState({
        date: "",
        name: "",
    });
    const [structureVaccines, setStructureVaccines] = useState([]);
    const [loading , setLoading] = useState(false);
    const [edditing, setEdditing] = useState(false);
    const today = new Date().toISOString().split("T")[0];
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (pet?.species === "gato") {
            setOptions(["Rabia", "Triple felina"]);
        } else if (pet?.species === "perro") {
            setOptions(["Rabia", "Sextuple", "Octuple"]);
        }
    }, [pet]);

    const handleAddVaccine = async (e) => {
        e.preventDefault();
        if (!newVaccine.date || !newVaccine.name) {
            alert("Debe completar todos los campos");
            return;
        }
        newVaccine.name = newVaccine.name.trim(); 
        setLoading(true);
        const response = await PetApi.addVaccineToPet(pet.id, newVaccine.date, newVaccine.name, userId);
        setLoading(false);
        if (response) {
            newVaccine.date = Timestamp.fromDate(new Date(newVaccine.date));
            setVaccines([...vaccines, newVaccine]);
            setNewVaccine({
                date: "",
                name: "",
                creatorId: userId,
            });
            setOpenForm(false);
        } else {
            alert("Error al añadir la vacuna");
        }
    }

    const handleDeleteVaccine = async (vaccineId) => {
        setLoading(true);
        const response = await PetApi.deleteVaccineFromPet(vaccineId);
        setLoading(false);
        if (response) {
            const newVaccines = vaccines.filter((v) => v.id !== vaccineId);
            setVaccines(newVaccines);
        } else {
            alert("Error al eliminar la vacuna");
        }
    }

    const showVaccineRecommendation = (vaccine) => {
        if (pet?.species === "gato") {
            if (vaccine.name === "Rabia" || vaccine.name === "Triple felina") {
                return true;
            }
            return false;
        }
        if (pet?.species === "perro") {
            if (vaccine.name === "Rabia" || vaccine.name === "Sextuple" || vaccine.name === "Octuple") {
                return true;
            }
            return false;
        }
        return false;
    }

    // chequea si la vacuna esta al dia
    const checkVaccine = (name) => {
        if (pet?.species === "gato") {
            if (name === "Rabia") {
                //buscamos en structureVaccines la vacuna de la rabia
                const vaccines = structureVaccines.find((v) => v.name === "Rabia")?.dates;
                if (vaccines.length > 0) {
                    const lastVaccine = vaccines[0];
                    const lastVaccineDate = lastVaccine.date.toDate();
                    const today = new Date();
                    const diff = today - lastVaccineDate;
                    const diffDays = diff / (1000 * 60 * 60 * 24);
                    if (diffDays > 365) {
                        return false;
                    }
                    return true;
                }
                return false;
            } else if (name === "Triple felina") {
                //buscamos en structureVaccines la vacuna de la triple felina
                const vaccines = structureVaccines.find((v) => v.name === "Triple felina")?.dates;
                if (vaccines.length > 0) {
                    const lastVaccine = vaccines[0];
                    const lastVaccineDate = lastVaccine.date.toDate();
                    const today = new Date();
                    const diff = today - lastVaccineDate;
                    const diffDays = diff / (1000 * 60 * 60 * 24);
                    if (diffDays > 365) {
                        return false;
                    }
                    return true;
                }
                return false;
            }
            return false;
        } else if (pet?.species === "perro") {
            if (name === "Rabia") {
                //buscamos en structureVaccines la vacuna de la rabia
                const vaccines = structureVaccines.find((v) => v.name === "Rabia")?.dates;
                if (vaccines.length > 0) {
                    const lastVaccine = vaccines[0];
                    const lastVaccineDate = lastVaccine.date.toDate();
                    const today = new Date();
                    const diff = today - lastVaccineDate;
                    const diffDays = diff / (1000 * 60 * 60 * 24);
                    if (diffDays > 365) {
                        return false;
                    }
                    return true;
                }
                return false;
            } else if (name === "Sextuple" || name === "Octuple"){
                //buscamos en structureVaccines la vacuna de la sextuple u octuple
                const vaccines = structureVaccines.find((v) => v.name === "Sextuple" || v.name === "Octuple")?.dates;
                if (vaccines.length > 0) {
                    const lastVaccine = vaccines[0];
                    const lastVaccineDate = lastVaccine.date.toDate();
                    const today = new Date();
                    const diff = today - lastVaccineDate;
                    const diffDays = diff / (1000 * 60 * 60 * 24);
                    if (diffDays > 365) {
                        return false;
                    }
                    return true;
                }
                return false;
            }
            return false;
            
        }
        return false;
    }

    const recommendedVaccines = (vaccine) => {
        const name = vaccine.name;
        if (pet?.species === "perro"){
            if (name === "Rabia" || name === "Sextuple" || name === "Octuple") {
                if (checkVaccine(name)) {
                    return "Vacuna al día";
                } else {
                    return "Vacuna atrasada";
                }
            }
            return "";
        } else if (pet?.species === "gato") {
            if (name === "Rabia" || name === "Triple felina") {
                if (checkVaccine(name)) {
                    return "Vacuna al día";
                } else {
                    return "Vacuna atrasada";
                }
            }
            return "";
        }
        return "";
    }
    

    useEffect(() => {
        let structureVaccines = [];
        if (pet?.species === "gato") {
            structureVaccines = [
                {
                    name: "Rabia",
                    dates: [],
                },
                {
                    name: "Triple felina",
                    dates: [],
                },
            ];
        } else if (pet?.species === "perro") {
            structureVaccines = [
                {
                    name: "Rabia",
                    dates: [],
                },
                {
                    name: "Sextuple",
                    dates: [],
                },
                {
                    name: "Octuple",
                    dates: [],
                },
            ];
        }
        for (let i = 0; i < vaccines.length; i++) {
            let vaccine = vaccines[i];
            //chequea si existe una vacuna con el mismo nombre
            let index = structureVaccines.findIndex((v) => v.name == vaccine.name);
            if (index === -1) {
                structureVaccines.push({
                    name: vaccine.name,
                    dates: [vaccine]
                });
            } else {
                structureVaccines[index].dates.push(vaccine);
            }
        }
        const timestampToDate = (timestamp) => new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000); 
        //ordenamos las fechas de las vacunas
        for (let i = 0; i < structureVaccines.length; i++) {
            structureVaccines[i].dates.sort((a, b) => timestampToDate(b.date) - timestampToDate(a.date));
        }
        setStructureVaccines(structureVaccines);
    }, [vaccines]);


    return (
        <div 
            style={{
                position: "relative",
            }}>
            <h3>Vacunas</h3>
            {!openForm &&
                <button 
                    style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        backgroundColor: "white",
                        borderRadius: 20,
                        padding: 10,
                        border: "1px solid #ccc",
                        cursor: "pointer",
                    }}
                    onClick={() => setEdditing(!edditing)}
                    >
                        {edditing ? "Terminar edición" : "Editar"}
                    </button>
            }
            {!openForm && 
                <button onClick={() =>{setOpenForm(true); setEdditing(false)}} style={{
                    backgroundColor: "white",
                    borderRadius: 20,
                    padding: 10,
                    border: "1px solid #ccc",
                    cursor: "pointer",
                }}>
                    <FontAwesomeIcon icon={faPlus} />
                    Añadir vacuna
                </button>
            }
            {openForm && (
                <form style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    padding: 10,
                    border: "1px solid #ccc",
                    borderRadius: 10,
                }}>
                    <h4>Añadir vacuna</h4>
                    {loading && <div style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <ReactLoading type="spin" color="black" height={50} width={50} />
                    </div>}
                    <div style={{
                        position: "absolute",
                        top: 20,
                        right: 10,
                    }}>
                        <button 
                            style={{
                                backgroundColor: "white",
                                borderRadius: 20,
                                padding: 5,
                                border: "1px solid #ccc",
                                cursor: "pointer",
                                width: 80,
                                display: "flex",
                                justifyContent: "space-evenly",
                            }}
                            onClick={() => setOpenForm(false)}
                        >
                            Cerrar 
                            <FontAwesomeIcon icon={faX} />
                        </button>
                    </div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Fecha"
                            maxDate={dayjs(today)}
                            minDate={dayjs(pet?.birth) || dayjs("2000-01-01")}
                            value={newVaccine.date || null}
                            onChange={(newValue) => setNewVaccine({...newVaccine, date: newValue})}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                    
                    <Autocomplete
                    style={{marginBottom: 10, marginTop: 10}}
                        freeSolo
                        disablePortal
                        id='vaccines'
                        options={options}
                        renderInput={(params) => 
                            <TextField {...params} label="Nombre" />}
                        value={newVaccine.name}
                        onChange={(e, value) => setNewVaccine({...newVaccine, name: value})}
                    />
                    <button 
                        style={{
                            backgroundColor: "white",
                            borderRadius: 20,
                            padding: 10,
                            border: "1px solid #ccc",
                            cursor: "pointer",
                            width: 200,
                            alignSelf: "center",
                        }}
                        type="submit" onClick={handleAddVaccine}
                    >Añadir</button>
                </form>
            )}
            <ul>
                {structureVaccines.map((vaccine) => (
                    <div  key={vaccine.name}>
                    <li>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}>
                            <p>{vaccine.name}</p>
                            {showVaccineRecommendation(vaccine) &&
                            <p
                                style={{
                                    color: checkVaccine(vaccine.name) ? "green" : "red",}}
                            
                            >{recommendedVaccines(vaccine)}</p>
                            }
                        </div>
                        <ul>
                            {vaccine.dates.map((date, index) => (
                                <li key={index} 
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}>
                                    <p>{date.date.toDate().toLocaleDateString()}</p>
                                    {(date.creatorId === userId && edditing) &&
                                    <button 
                                        style={{
                                            height: 30,
                                            backgroundColor: "white",
                                            borderRadius: 20,
                                            padding: 5,
                                            border: "1px solid #ccc",
                                            cursor: "pointer",}}
                                        onClick={() => handleDeleteVaccine(date.id)}
                                        >Borrar</button>
                                    }
                                </li>
                            ))}
                        </ul>
                    </li>
                    <hr />
                    </div>
                ))}
            </ul>
        </div>
    );
}

export default Vaccines;